// Moneda
export const useCurrencyStore = defineStore('currency', () => {
  const currency = ref('MXN')

  const updateCurrencyByCountry = async (country: string) => {
    currency.value = 'MXN'
  }

  return { currency, updateCurrencyByCountry }
})
